import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import moment from 'moment';
/**
 * Generated class for the CoRoamEventlistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-roam-eventlist',
  templateUrl: 'co-roam-eventlist.html',
})
export class CoRoamEventlistPage {
  private today: string;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.today = moment().format('LLLL');
  }

  ionViewDidLoad() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/co-roam-eventlist/co-roam-eventlist.ts